import React from 'react'
import styles from './style'
import injectSheet from 'react-jss'
import toRadian from 'helpers/toRadian'
import { DOWNTILT_PREVIEW_DIMENSIONS, ANALYTIC_ZONE_OPACITIES, CAMERA_SELECTED_RGB_COLORS } from 'helpers/globals'

const { maxCameraIconHeight, width, cameraIconHeight } = DOWNTILT_PREVIEW_DIMENSIONS

class DowntiltDisplay extends React.Component {
  componentDidMount = _ => this.updateCanvas()
  componentDidUpdate = _ => this.updateCanvas()

  updateCanvas = _ => {
    const { angle, tilt, cameraPxHeight, otherAngle, distance, resolution, showAnalyticZones, color, ppfZoneBorders, ppfZoneColors } = this.props
    const startAngle = toRadian(-tilt)
    const endAngle = toRadian(angle - tilt)
    const height = cameraPxHeight > maxCameraIconHeight ? cameraIconHeight / 2 : maxCameraIconHeight - cameraPxHeight + cameraIconHeight / 2
    const canvas = this.refs.blindSpotCone
    const ctx = canvas.getContext('2d')

    // handle scale and clear
    const ratio = window.devicePixelRatio
    canvas.width = width * ratio
    canvas.height = DOWNTILT_PREVIEW_DIMENSIONS.height * ratio

    ctx.scale(ratio, ratio)
    ctx.save()
    ctx.setTransform(1, 0, 0, 1, 0, 0)
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.restore()

    ctx.beginPath()
    ctx.moveTo(0, height)
    ctx.arc(0, height, width - 5, startAngle, endAngle)
    ctx.strokeStyle = `rgba(${CAMERA_SELECTED_RGB_COLORS[color]}, 0.80)`
    ctx.closePath()
    ctx.stroke()

    let distances = []

    if (!showAnalyticZones) {
      ctx.fillStyle = `rgba(${CAMERA_SELECTED_RGB_COLORS[color]}, 0.55)`
      ctx.fill()
      return
    }

    for (let i = 1; i < ppfZoneBorders.length; i++) {
      const calculatedDistance = (resolution * 180) / (ppfZoneBorders[i] * otherAngle * Math.PI)
      if (calculatedDistance < distance) {
        distances.push((width - 5) * calculatedDistance / distance)
      } else break
    }

    if (distances.length > 0) {
      ctx.beginPath()
      ctx.moveTo(0, height)
      ctx.arc(0, height, distances[0], startAngle, endAngle)
      ctx.fillStyle = `rgba(${CAMERA_SELECTED_RGB_COLORS[ppfZoneColors[0]]}, ${ANALYTIC_ZONE_OPACITIES[0]})`
      ctx.fill()

      for (let i = 1; i < distances.length; i++) {
        ctx.beginPath()
        ctx.arc(0, height, distances[i - 1], startAngle, endAngle)
        ctx.arc(0, height, distances[i], endAngle, startAngle, true)
        ctx.fillStyle = `rgba(${CAMERA_SELECTED_RGB_COLORS[ppfZoneColors[i]]}, ${ANALYTIC_ZONE_OPACITIES[i]})`
        ctx.fill()
      }

      ctx.beginPath()
      ctx.arc(0, height, distances[distances.length - 1], startAngle, endAngle)
      ctx.arc(0, height, width - 5, endAngle, startAngle, true)
      ctx.fillStyle = `rgba(${CAMERA_SELECTED_RGB_COLORS[ppfZoneColors[distances.length]]}, ${ANALYTIC_ZONE_OPACITIES[distances.length]})`
      ctx.fill()
    } else {
      ctx.beginPath()
      ctx.moveTo(0, height)
      ctx.arc(0, height, width - 5, startAngle, endAngle)
      ctx.fillStyle = `rgba(${CAMERA_SELECTED_RGB_COLORS[ppfZoneColors[0]]}, ${ANALYTIC_ZONE_OPACITIES[0]})`
      ctx.fill()
    }
  }

  render = _ => {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        <canvas ref='blindSpotCone' width={width} height={DOWNTILT_PREVIEW_DIMENSIONS.height} />
      </div>
    )
  }
}

export default injectSheet(styles)(DowntiltDisplay)



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/DowntiltDisplay/index.js